import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/**
 * Spec 032 US6 — user-defined custom recurring Q&A.
 *
 * Each entry is a (questionPattern, answer) pair the resolver uses to
 * answer fields that aren't in the fixed canonical set. The pattern is
 * a free-form string the user types in their own words — the resolver
 * matches it against the form field's label / name / aria-label by
 * case-insensitive substring (FR-009, contracts/api.md §6).
 *
 * Cap: `MAX_CUSTOM_ANSWERS_PER_USER` (default 100, see
 * `application-profile.config.ts`) — past that the create endpoint
 * returns 422 and the user must dedupe first.
 */
export const customAnswerSchema = z.object({
  id: z.string(),
  questionPattern: z.string().trim().min(1).max(200),
  answer: z.string().trim().min(1).max(2000),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const createCustomAnswerSchema = z.object({
  questionPattern: z.string().trim().min(1).max(200),
  answer: z.string().trim().min(1).max(2000),
});

export const updateCustomAnswerSchema = z.object({
  questionPattern: z.string().trim().min(1).max(200).optional(),
  answer: z.string().trim().min(1).max(2000).optional(),
});

export class CreateCustomAnswerDto extends createZodDto(createCustomAnswerSchema) {}
export class UpdateCustomAnswerDto extends createZodDto(updateCustomAnswerSchema) {}

export type CustomAnswerResponse = z.infer<typeof customAnswerSchema>;
export type CustomAnswerListResponse = { items: CustomAnswerResponse[] };
